import React from 'react';
import { Columns } from '@components/Columns';
import {
  StyledOneRegistrySectionBackImage,
  CharityTextPairing,
  StyledOneRegistrySection,
  HeroTextColumn,
} from './OneRegistrySection.styles';
import { registryPageData } from '@data-ts/pages/registry';

const oneRegistrySectionData = registryPageData.oneRegistrySection;

interface OneRegistrySectionProps {}

export const OneRegistrySection: React.FC<OneRegistrySectionProps> = () => {
  return (
    <StyledOneRegistrySectionBackImage imageUrl="registry-v2/one-registry/one-registry-bottom-wave-bg.svg" as="section" id="One_Registry">
      <StyledOneRegistrySection paddingY={[12]}>
        <HeroTextColumn centered verticalAlign="center">
          <Columns.Column width={6}>
            <CharityTextPairing
              alignment="center"
              eyebrow={oneRegistrySectionData.eyebrow}
              eyebrowColor="humanaDark4"
              eyebrowVariant="sectionEyeBrow20"
              eyebrowTagName="h2"
              title={oneRegistrySectionData.title}
              titleVariant="hed72Hero"
              titleColor="humanaDark6"
              titleTagName="h2"
              body={oneRegistrySectionData.body}
              bodyVariant="dek20"
              bodyColor="neutra6"
              bodyTagName="p"
            />
          </Columns.Column>
        </HeroTextColumn>
      </StyledOneRegistrySection>
    </StyledOneRegistrySectionBackImage>
  );
};
